// extracted by mini-css-extract-plugin
export default {"customerExperienceContainer":"CustomerExperience_customerExperienceContainer__0Zxuc"};